import { useNavigate } from "react-router-dom";
import {
  BackgroundImage,
  Body,
  DirectoryItemContainer,
  ContentTitle,
  ContentSubtitle,
} from "./directory-item.styles";

const DirectoryItem = ({ category }) => {
  const { imageUrl, title, route } = category;
  const navigate = useNavigate();

  const onNavigateHandler = () => navigate(route);

  return (
    <DirectoryItemContainer onClick={onNavigateHandler}>
      <BackgroundImage imageUrl={imageUrl} />
      <Body>
        <ContentTitle>{title.toUpperCase()}</ContentTitle>
        <ContentSubtitle>Shop Now</ContentSubtitle>
      </Body>
    </DirectoryItemContainer>
  );
};

export default DirectoryItem;

//import "./directory-item.styles.scss";

// const DirectoryItem = ({ category }) => {
//   const { imageUrl, title } = category;
//   return (
//     <div className="directory-item-container">
//       <div
//         className="background-image"
//         style={{ backgroundImage: `url(${imageUrl})` }}
//       />
//       <div className="body">
//         <h2>{title}</h2>
//         <p>Shop Now</p>
//       </div>
//     </div>
//   );
// };

// export default DirectoryItem;
